var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconStation = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M15.75 9.76879C15.75 11.8398 14.071 13.5188 12 13.5188C9.92904 13.5188 8.25 11.8398 8.25 9.76879C8.25 7.69782 9.92904 6.01879 12 6.01879C14.071 6.01879 15.75 7.69782 15.75 9.76879ZM12 7.51879C10.7575 7.51879 9.75 8.52625 9.75 9.76879C9.75 11.0113 10.7575 12.0188 12 12.0188C13.2425 12.0188 14.25 11.0113 14.25 9.76879C14.25 8.52625 13.2425 7.51879 12 7.51879Z", fill: "#192325" }),
            React.createElement("path", { d: "M12 2.24951C7.86137 2.24951 4.5 5.53787 4.5 9.60251C4.5 11.1922 5.01638 12.7068 5.96761 13.9728L11.3922 21.4771C11.6916 21.8913 12.3084 21.8913 12.6078 21.4772L18.0558 13.9412C18.9857 12.6995 19.5 11.1883 19.5 9.60251C19.5 5.53787 16.1386 2.24951 12 2.24951ZM18 9.60251C18 10.8606 17.5928 12.0572 16.8477 13.0522L12 19.7576C12 19.7576 7.14902 13.0473 7.1402 13.0365C6.40277 12.0451 6 10.8544 6 9.60251C6 6.37376 8.68252 3.74951 12 3.74951C15.3175 3.74951 18 6.37376 18 9.60251Z", fill: "#192325" }))),
        alt: 'Station',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconStation;
//# sourceMappingURL=index.js.map